<template lang="pug">
.unistar-tables
  quotation-table(
    :data="starData.star_offer_price"
  )
  rights-and-interests-table(
    :data="starData.star_right_price"
  )
  execution-price-table(
    :data="starData.star_execution_price"
  )
</template>

<script>
import ExecutionPriceTable from './ExecutionPriceTable'
import QuotationTable from './QuotationTable'
import RightsAndInterestsTable from './RightsAndInterestsTable'
export default {
  props: {
    starData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {

    }
  },
  components: {
    RightsAndInterestsTable,
    QuotationTable,
    ExecutionPriceTable
  }
}
</script>

<style scoped lang="stylus">

</style>
